const initialState = {
  isError: false,
  isLoading: true,
  isSuccess: false,
  items: [],
};

export default initialState;
